// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"268":"c2069566","306":"c473bc9e","384":"8aac92ec"}[chunkId] + ".js";
};